import Fetcher from "../../../services/FetchService";
export default class FeatureService {
    static shouldShowFeature(featureInternalName, visibleFeatures) {
        return visibleFeatures.some((feature) => feature.internalName === featureInternalName);
    }
    static isGlobalFeatureEnabled(featureInternalName) {
        return Fetcher.getSingleResponse("/aviso/feature/isGlobalFeatureEnabled", {
            featureInternalName,
        });
    }
}
